/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_AttachInputs */

const vi_camera_station_attach = /** @type {(inputs: Camera_Station_AttachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gắn camera`)
};

/**

* @param {Camera_Station_AttachInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_attach = /** @type {((inputs?: Camera_Station_AttachInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_AttachInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_attach(inputs)
});